// extracted by mini-css-extract-plugin
export var link = "cta-sponsor-info-module--link--0a388";
export var sideColumnTitle = "cta-sponsor-info-module--side-column-title--1e31d";
export var text = "cta-sponsor-info-module--text--39c9f";